
import {
    BrowserRouter,
    Routes,
    Route,
} from "react-router"

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import Authenticator from './authenticator'
import BackgroundCheckForm from './Pages/BackgroundCheckForm'
import PreCheckForm from './Pages/PreCheckForm'
import BackgroundCheckResults from "./Pages/BackgroundCheckResults"
import AcceptCompanyInvitation from "./Pages/AcceptCompanyInvitation"
import AcceptHrInvitation from "./Pages/AcceptHrInvitation"
import ScrollToTop from "./Components/ScollToTop"
import GoogleAnalytics from "./Components/GoogleAnalytics"
import AuthenticatorAdmin from "./authenticatorAdmin"
import AuthenticatorExecutive from "./authenticatorExecutive"
import AuthenticatorQa from "./authenticatorQa"
import AuthenticatorCandidate from "./authenticatorCandidate"
import { ToastContainer } from "react-toastify"
import BackgroundCheckHitResults from "./Pages/BackgroundCheckHitResults"
import PreCheckFormSuccess from "./Pages/PreCheckFormSuccess"
import PreCheckFormFailed from "./Pages/PreCheckFormFailed"
import PreCheckView from "./Pages/PreCheckView"
import PreCheckCandidateView from "./Pages/PreCheckCandidateView"
import CandidateConsumerReport from "./Pages/CandidateConsumerReport"
import PreAdverseActionResponse from "./Pages/PreAdverseActionResponse"
import TruCheckInfographic from "./Pages/PreCheck/Components/TrucheckInfoGraphic"

const queryClient = new QueryClient()

const App = () => {

    return (
        <div>
            <QueryClientProvider client={queryClient}>
                <ToastContainer />
                <BrowserRouter>
                    <GoogleAnalytics />
                    <ScrollToTop />
                    <Routes>
                        {/* Public Routes */}
                        <Route path="/background-check-form" element={<BackgroundCheckForm />} />
                        <Route path="/pre-check-form" element={<PreCheckForm />} />
                        <Route path="/pre-check-form-success" element={<PreCheckFormSuccess />} />
                        <Route path="/pre-check-form-failed" element={<PreCheckFormFailed />} />
                        <Route path="/background-check-results" element={<BackgroundCheckResults />} />
                        <Route path="/background-check-hit-results" element={<BackgroundCheckHitResults />} />
                        <Route path="/accept-company-invitation" element={<AcceptCompanyInvitation />} />
                        <Route path="/accept-hr-invitation" element={<AcceptHrInvitation />} />
                        <Route path="/pre-check-view" element={<PreCheckView />} />
                        <Route path="/pre-check-candidate-view" element={<PreCheckCandidateView />} />
                        <Route path="/candidate-consumer-report/:reportKey" element={<CandidateConsumerReport />} />
                        <Route path="/pre-adverse-action-response/:responseKey" element={<PreAdverseActionResponse />} />

                        {
                            process.env.REACT_APP_SELECTED_ENV === "QA" &&
                            <Route path="*" element={<AuthenticatorQa />} />
                        }

                        {
                            process.env.REACT_APP_SELECTED_ENV === "EXECUTIVE" &&
                            <Route path="*" element={<AuthenticatorExecutive />} />
                        }

                        {
                            process.env.REACT_APP_SELECTED_ENV === "HR" &&
                            <Route path="*" element={<Authenticator />} />
                        }

                        {
                            process.env.REACT_APP_SELECTED_ENV === "ADMIN" &&
                            <Route path="*" element={<AuthenticatorAdmin />} />
                        }

                        {
                            process.env.REACT_APP_SELECTED_ENV === "CANDIDATE" &&
                            <Route path="*" element={<AuthenticatorCandidate />} />
                        }
                        <Route path="/trucheck-guide" element={<TruCheckInfographic />} />

                    </Routes>

                </BrowserRouter>
            </QueryClientProvider>
        </div>

    )
}

export default App
